import React from 'react';
import { avatarColor, initials } from '../lib/avatar';

export default function Avatar({ name, size = 32, shape = 'square', src, style }) {
  const radius = shape === 'circle' || shape === 'monogram'
    ? '50%' : Math.round(size * 0.28);
  const baseStyle = {
    width: size, height: size,
    fontSize: Math.round(size * 0.42),
    flexShrink: 0,
  };
  if (src) {
    return (
      <div style={{ ...baseStyle, borderRadius: radius, overflow: 'hidden', ...style }}>
        <img src={src} alt={name || ''} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </div>
    );
  }
  return (
    <div
      aria-label={name}
      style={{
        ...baseStyle,
        borderRadius: radius,
        background: avatarColor(name),
        color: '#fff',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 600,
        letterSpacing: '0.01em',
        fontFamily: 'var(--font-display)',
        ...style,
      }}
    >
      {initials(name)}
    </div>
  );
}
